"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotSet = exports.isSet = exports.calculateDayReimbursement = exports.calculateTotalReimbursement = exports.roundNumberTo2Decimals = exports.isAtMostNChar = exports.isAtLeastNChar = exports.isEmptyStringOrNullish = exports.checkIfStringContainsSpecialCharacters = exports.findUserDataInPassword = exports.getUserNameFromEmail = exports.obfuscateString = exports.findDisallowedWordInPassword = exports.toAmountForCurrency = exports.toAmount = exports.toDinero = void 0;
exports.isNumeric = isNumeric;
const dinero = __importStar(require("dinero.js"));
const consts_1 = require("../consts");
const common_1 = require("../consts/common");
const passwordDisallowedWords_1 = require("../consts/passwordDisallowedWords");
function isNumeric(num) {
    return !isNaN(num);
}
const toDinero = (amount, options) => dinero.default(Object.assign({ amount: Math.round(amount * 100) }, options));
exports.toDinero = toDinero;
/**
 * @deprecated Use toAmoundForCurrency instead
 */
const toAmount = (dineroInstance) => dineroInstance.getAmount() / 100;
exports.toAmount = toAmount;
const toAmountForCurrency = (dineroInstance, currency) => {
    if (!dineroInstance) {
        throw new Error("Dinero instance missing");
    }
    if (!currency) {
        throw new Error("Currency missing");
    }
    const precision = consts_1.Currencies[currency].decimal_digits;
    return dineroInstance.toRoundedUnit(precision);
};
exports.toAmountForCurrency = toAmountForCurrency;
/**
 * Searches for a disallowed word in a password and returns either the obfuscated word or the original word.
 *
 * @param {string} word - The password to check for disallowed words.
 * @param {boolean} [returnObfuscated=true] - Whether to return the obfuscated version of the disallowed word.
 * @returns {string|null} - The disallowed word found in the password (either obfuscated or original), or null if no word is found.
 */
const findDisallowedWordInPassword = (word, returnObfuscated = true) => {
    const lowerCaseWord = word.toLowerCase();
    for (const disallowedWord of passwordDisallowedWords_1.PASSWORD_DISALLOWED_WORDS) {
        if (lowerCaseWord.includes(disallowedWord.toLowerCase())) {
            return returnObfuscated ? (0, exports.obfuscateString)(disallowedWord) : disallowedWord;
        }
    }
    return null;
};
exports.findDisallowedWordInPassword = findDisallowedWordInPassword;
/**
 * Obfuscates a string by replacing all characters between the first and last character with asterisks.
 *
 * @param {string} str - The string to obfuscate.
 * @returns {string} - The obfuscated string.
 */
const obfuscateString = (str) => {
    if (str.length <= 2) {
        return str;
    }
    const firstChar = str[0];
    const lastChar = str[str.length - 1];
    const middleChars = "*".repeat(str.length - 2);
    return `${firstChar}${middleChars}${lastChar}`;
};
exports.obfuscateString = obfuscateString;
/**
 * Extracts the username portion of an email address (i.e., the part before the "@" symbol and any email alias).
 *
 * @param {string} email - The email address to extract the username from.
 * @returns {string} - The username portion of the email address, with any email alias removed.
 * @throws {Error} - If the email address is invalid.
 */
const getUserNameFromEmail = (email) => {
    const atIndex = email.indexOf("@");
    if (atIndex === -1) {
        throw new Error(`Invalid email address: ${email}`);
    }
    const plusIndex = email.indexOf("+");
    const endIndex = plusIndex !== -1 && plusIndex < atIndex ? plusIndex : atIndex;
    return email.substring(0, endIndex);
};
exports.getUserNameFromEmail = getUserNameFromEmail;
/**
 * Finds the first piece of user data that appears in the password, or returns null if no data is found.
 *
 * @param {object} userData - An object containing the user's email, first name, and last name.
 * @param {string} password - The password to check for user data.
 * @returns {string|null} - The first piece of user data found in the password, or null if no data is found.
 */
const findUserDataInPassword = ({ email, firstName, lastName }, password) => {
    const lowerCasePassword = password.toLowerCase();
    const emailUserName = (0, exports.getUserNameFromEmail)(email); // portion of the email before the "@""
    const userDataArray = [firstName, lastName, emailUserName].map((data) => data.toLowerCase());
    return userDataArray.find((userData) => lowerCasePassword.includes(userData)) || null;
};
exports.findUserDataInPassword = findUserDataInPassword;
/**
 * Checks if a string contains any special characters outside of the ranges 0-9, a-z, A-Z.
 *
 * @param {string} str - The input string to check.
 * @returns {boolean} `true` if the input string contains any special characters, `false` otherwise.
 */
const checkIfStringContainsSpecialCharacters = (str) => {
    const regex = /^[0-9a-zA-Z]*$/;
    return !regex.test(str);
};
exports.checkIfStringContainsSpecialCharacters = checkIfStringContainsSpecialCharacters;
const isEmptyStringOrNullish = (input) => input === "" || typeof input === "undefined" || input === null;
exports.isEmptyStringOrNullish = isEmptyStringOrNullish;
const isAtLeastNChar = (input, numberOfChars) => (input === null || input === void 0 ? void 0 : input.length) >= numberOfChars;
exports.isAtLeastNChar = isAtLeastNChar;
const isAtMostNChar = (input, numberOfChars) => (input === null || input === void 0 ? void 0 : input.length) <= numberOfChars;
exports.isAtMostNChar = isAtMostNChar;
/**
 * Rounds number to 2 decimals by cutting off everything after the third decimal then rounds HALF_UP
 *
 * Examples: 39.9959 => 40.00, 39.9949 => 39.99
 */
const roundNumberTo2Decimals = (num) => Math.round((num + (Number(num) >= 0 ? Number.EPSILON : -Number.EPSILON)) * 100) / 100;
exports.roundNumberTo2Decimals = roundNumberTo2Decimals;
const calculateTotalReimbursement = (dailyExpenses, perDiemDestinations) => {
    const destinationMap = new Map(perDiemDestinations.map((destination) => [destination._id, destination]));
    let totalValue = (0, exports.toDinero)(0);
    dailyExpenses.forEach((day, index) => {
        const destination = destinationMap.get(day.destination);
        if (destination) {
            const dayReimbursement = (0, exports.calculateDayReimbursement)(day, dailyExpenses, index, destination);
            totalValue = totalValue.add((0, exports.toDinero)(dayReimbursement));
        }
    });
    return (0, exports.toAmount)(totalValue);
};
exports.calculateTotalReimbursement = calculateTotalReimbursement;
const calculateDayReimbursement = (day, tripDailyExpenses, index, destination) => {
    var _a, _b, _c, _d, _e, _f;
    const isLastDay = index === tripDailyExpenses.length - 1;
    const mealAllowance = (0, exports.toDinero)((_a = (index === 0 || index === tripDailyExpenses.length - 1 ? destination === null || destination === void 0 ? void 0 : destination.halfDay : destination === null || destination === void 0 ? void 0 : destination.fullDay)) !== null && _a !== void 0 ? _a : 0);
    const reimbursement = (0, exports.toDinero)((_b = destination === null || destination === void 0 ? void 0 : destination.fullDay) !== null && _b !== void 0 ? _b : 0);
    let substractableAmount = (0, exports.toDinero)(0);
    if ((_c = day === null || day === void 0 ? void 0 : day.expenditure) === null || _c === void 0 ? void 0 : _c.breakfast) {
        substractableAmount = substractableAmount.add(reimbursement.multiply(common_1.PER_DIEM_BREAKFAST_RATE));
    }
    if ((_d = day === null || day === void 0 ? void 0 : day.expenditure) === null || _d === void 0 ? void 0 : _d.lunch) {
        substractableAmount = substractableAmount.add(reimbursement.multiply(common_1.PER_DIEM_LUNCH_RATE));
    }
    if ((_e = day === null || day === void 0 ? void 0 : day.expenditure) === null || _e === void 0 ? void 0 : _e.dinner) {
        substractableAmount = substractableAmount.add(reimbursement.multiply(common_1.PER_DIEM_DINNER_RATE));
    }
    // Substractable amount can never be higher than total meal allowance.
    let totalReimbursement = substractableAmount.greaterThan(mealAllowance) ? (0, exports.toDinero)(0) : mealAllowance.subtract(substractableAmount);
    // If accomodation is not checked, it gives +value, if its checked, it gives 0
    if (!((_f = day === null || day === void 0 ? void 0 : day.expenditure) === null || _f === void 0 ? void 0 : _f.accommodation) && !isLastDay) {
        totalReimbursement = totalReimbursement.add((0, exports.toDinero)((destination === null || destination === void 0 ? void 0 : destination.accommodation) || 0));
    }
    return (0, exports.toAmount)(totalReimbursement);
};
exports.calculateDayReimbursement = calculateDayReimbursement;
const isSet = (value) => value !== undefined && value !== null;
exports.isSet = isSet;
const isNotSet = (value) => !(0, exports.isSet)(value);
exports.isNotSet = isNotSet;
